<template>
  <Drawer :drawer="drawer" :customTitle="true" :size="820" @close="close">
    <template slot="title">
      <span>
        <!-- <span
          :class="{ active: !active }"
          class="read"
          @click.stop="handleClick(0)"
        >详情</span
        > -->
        <span
          class="active read"
        >日志记录</span
        >
      </span>
    </template>
    <div class="view">
      <template v-if="!active">
        <div class="panel">
          <span class="panel-title">
            <img src="@/assets/images/bill/panel-icon.png" />
            POD</span
            >
          <div class="btn" @click="handleUploadPod(0)">
            <svg-icon iconClass="upload" className="icon" />
            上传POD
          </div>
        </div>
        <div class="pod-list">
          <BaseTable :height="480" :tableData="tableDataPol" :isPager="false">
            <template slot="podDate" slot-scope="row">
              <p style="text-align: left">
                <span class="lable">POD</span>
                <span class="value">{{ row.scope.podFileId ? "是" : "否" }}</span>
              </p>
              <p style="text-align: left">
                <span class="lable">POD日期</span>
                <span class="value">{{ row.scope.podDate | formatterTime }}</span>
              </p>
              <p style="text-align: left">
                <span class="lable">POD时效</span>
                <span class="value">{{ row.scope.podPrescription }}</span>
              </p>
            </template>
            <template slot="deliveryDate" slot-scope="row">
              <p style="text-align: left">
                <span class="lable">递送件数</span>
                <span class="value">{{ row.scope.deliveryQty }}</span>
              </p>
              <p style="text-align: left">
                <span class="lable">递送板数</span>
                <span class="value">{{ row.scope.deliveryCbm }}</span>
              </p>
              <p style="text-align: left">
                <span class="lable">递送日期</span>
                <span class="value">{{
                  row.scope.deliveryDate | formatterTime
                }}</span>
              </p>
              <p style="text-align: left">
                <span class="lable">递送时效</span>
                <span class="value">{{ row.scope.deliveryPrescription }}</span>
              </p>
            </template>
            <template slot="isISA" slot-scope="row">
              <div :style="{ color: row.scope.isISA ? '#35BA83' : '' }">{{
                row.scope.isISA ? "是" : "否"
              }}</div>
              <div v-if="row.scope.isISA" class="newUpload flex_c_c" @click="viewIsa(row.scope)">查看</div>
              <div :class="['newUpload', 'flex_c_c', !row.scope.isISA && 'upload']" @click="uploadISA(row.scope)">
                {{ row.scope.isISA ? '重新上传' : '上传' }}
              </div>
            </template>
            <template slot="isOwerISA" slot-scope="row">
              <div :style="{ color: row.scope.isOwerISA ? '#35BA83' : '' }">{{
                row.scope.isOwerISA ? "是" : "否"
              }}</div>
              <div v-if="row.scope.isOwerISA" class="newUpload flex_c_c" @click="viewRetentionIsa(row.scope)">查看</div>
              <div :class="['newUpload', 'flex_c_c', !row.scope.isOwerISA && 'upload']" @click="uploadRetentionISA(row.scope)">
                {{ row.scope.isOwerISA ? '重新上传' : '上传' }}
              </div>
            </template>
            <template slot="opt" slot-scope="row">
              <div :style="{ color: row.scope.podGuid ? '#35BA83' : '' }">{{
                row.scope.podGuid ? "是" : "否"
              }}</div>
              <div v-if="row.scope.podGuid" class="newUpload flex_c_c" @click="viewPod(row.scope, 0)">查看</div>
              <div :class="['newUpload', 'flex_c_c', !row.scope.podGuid && 'upload']" @click="handleUploadPod(1, row.scope)">
                {{ row.scope.podGuid ? '重新上传' : '上传' }}
              </div>
            </template>
          </BaseTable>
        </div>
        <div class="panel">
          <span class="panel-title">
            <img src="@/assets/images/bill/panel-icon.png" />
            BOL</span
          >
        </div>
        <div class="pod-list">
          <BaseTable :height="240" :tableData="tableDataBol" :isPager="false">
            <template slot="opt" slot-scope="row">
              <el-button
                type="text"
                @click="viewPod(row.scope, 1)"
              >查看</el-button
              >
            </template>
          </BaseTable>
        </div>
        <div class="panel" style="margin-top: 20px">
          <span class="panel-title">
            <img src="@/assets/images/bill/panel-icon.png" />
            费用
          </span>
          <div class="add" @click="dialogVisible2 = true">
            <img src="@/assets/images/add.png" />
            新增
          </div>
        </div>
        <div class="pod-list">
          <BaseTable :height="240" :tableData="tableDataFree" :isPager="false">
            <template slot="recievebleAmount" slot-scope="row">
              {{ row.scope.recievebleAmount }} {{ currency }}
            </template>
            <template slot="payableAmount" slot-scope="row">
              {{ row.scope.payableAmount }} {{ currency }}
            </template>
          </BaseTable>
        </div>
      </template>
      <template v-else>
        <div class="panel">
          <BaseTable
            :height="height"
            :tableData="tableData"
            :isPager="false"
          >
            <template slot="index" slot-scope="row">
              {{ tableData.columns.indexOf(row.scope) + 1 }}
            </template>
            <template slot="description" slot-scope="row">
              <div v-html="row.scope.description"></div>
            </template>
          </BaseTable>
        </div>
      </template>
      <UploadBodDialog
        :dialogVisible="dialogVisible"
        :bolOptions="tableDataBol.columns"
        :mblSendTypeId="mblSendWayId"
        :qty="rowData?.qty"
        :editData="editData"
        :type="type"
        @cancel="cancel"
        @ok="ok"
      ></UploadBodDialog>
      <UploadISADialog
        :dialogVisible="dialogVisible1"
        :PODId="editData?.id"
        @cancel="dialogVisible1 = false"
        @ok="ok"
      >
      </UploadISADialog>
      <AddTruckFreeDialog
        :dialogVisible="dialogVisible2"
        :mblSendTypeId="mblSendWayId"
        @cancel="dialogVisible2 = false"
        @ok="ok"
      >
      </AddTruckFreeDialog>
      <UploadRetentionIsaDialog
        :dialogVisible="dialogVisible3"
        :PODId="editData?.id"
        @cancel="dialogVisible3 = false"
        @ok="ok"
      >
      </UploadRetentionIsaDialog>
    </div>
  </Drawer>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
const BaseTable = () => import('@/components/table/BaseTable')
import UploadBodDialog from './UploadBodDialog'
import UploadISADialog from './UploadISADialog'
import AddTruckFreeDialog from './AddTruckFreeDialog'
import UploadRetentionIsaDialog from './UploadRetentionIsaDialog'
import { getMBLFollowUpList } from '@/api/bill'
import config from '@/utils/config'
export default {
  components: {
    Drawer,
    BaseTable,
    UploadBodDialog,
    UploadISADialog,
    AddTruckFreeDialog,
    UploadRetentionIsaDialog
  },
  filters: {
    formatterTime(date) {
      if (date) {
        return date.substr(0, 16)
      } else {
        return ''
      }
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    mblSendWayId: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 0
    } // 0: 卡派列表 1：整柜直送
  },
  data() {
    return {
      config,
      tableDataPol: {
        fileds: [
          {
            filed: 'podDate',
            label: 'POD信息',
            width: '220px',
            isCustom: true
          },
          {
            filed: 'deliveryDate',
            label: '递送信息',
            width: '220px',
            isCustom: true
          },
          {
            filed: 'supplierCode',
            label: '卡车公司代码',
            width: '100px'
          },
          {
            filed: 'proNo',
            label: 'PRO#',
            width: '80px'
          },
          {
            filed: 'isISA',
            label: 'ISA',
            width: '90px',
            isCustom: true
          },
          // {
          //   filed: 'isOwerISA',
          //   label: '自留ISA',
          //   width: '90px',
          //   isCustom: true
          // },
          {
            filed: 'opt',
            label: 'POD',
            width: '90px',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      tableDataBol: {
        fileds: [
          {
            filed: 'supplierName',
            label: '卡车公司',
            width: ''
          },
          {
            filed: 'proNo',
            label: 'PRO#',
            width: ''
          },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: '',
            formatter: (row) => {
              return row.createdOn.substr(0, 16)
            }
          },
          {
            filed: 'createdName',
            label: '上传人',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      tableDataFree: {
        fileds: [
          {
            filed: 'code',
            label: '卡车公司代码',
            width: '145px'
          },
          {
            filed: 'recievebleAmount',
            label: '应收',
            width: '145px',
            isCustom: true
          },
          {
            filed: 'payableAmount',
            label: '应付',
            width: '145px',
            isCustom: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      tableData: {
        fileds: [
          {
            filed: 'createdName',
            label: '创建人',
            width: '150'
          },
          {
            filed: 'createdOn',
            label: '创建时间 ',
            width: '150'
          },
          {
            filed: 'description',
            label: '描述',
            width: '',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      editData: {},
      active: 1,
      height: 0
    }
  },
  computed: {},
  watch: {
    drawer(val) {
      if (val) {
        // this.getList()
        this.getLogList()
        this.$nextTick(() => {
          const logBody = document.querySelectorAll('.drawer-content')
          this.height = logBody[logBody.length - 1].offsetHeight - 100
        })
      }
    }
  },
  mounted() {},
  methods: {
    close() {
      this.editData = {}
      this.active = 0
      this.$emit('close')
    },
    async getLogList() {
      const data = {
        id: this.rowData.mblId
      }
      try {
        const result = await getMBLFollowUpList(data)
        if (result.success) {
          // this.mainItem = []
          const arr = []
          result.data.map((item) => {
            item.events.map((item) => {
              arr.push(item)
            })
          })
          this.tableData.columns = arr
          // config.billStatusOptions.shift()
          // const arr = [...config.billStatusOptions]
          // arr.shift()
          // console.log('config.billStatusOptions.shift()', arr)
          // const sideArr = result.data.map((item) => {
          //   this.mainItem.push(item.events.reverse())
          //   // console.log('config.billStatusOptions.shift()', arr, config.billStatusOptions)
          //   item.status = arr.find((a) => +a.value === item.status).label
          //   return {
          //     name: item.status,
          //     new: item.hasNewFollowUp,
          //     length: item.events.length
          //   }
          // })
          // this.typeItems = sideArr
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // async getList() {
    //   try {
    //     const res = await truckDetail({
    //       mblSendWayId: this.mblSendWayId
    //     })
    //     if (res.success) {
    //       this.tableDataPol.columns = res.data.pod
    //       this.tableDataBol.columns = res.data.bol
    //       this.tableDataFree.columns = res.data.surcharge
    //       // this.tableData.columns = res.data.dispatch
    //     } else {
    //       this.$message.error(res.errorMessage)
    //     }
    //   } catch (error) {
    //     console.error(error)
    //   }
    // },
    ok() {
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
      this.getList()
    },
    handleUploadPod(type, row) {
      this.dialogVisible = true
      type && (this.editData = row)
    },
    cancel() {
      this.editData = {}
      this.dialogVisible = false
    },
    uploadISA(row) {
      this.editData = row
      this.dialogVisible1 = true
    },
    viewPod(row, type) {
      const { podFileName, fileName } = row
      const name = podFileName || fileName
      const suffix = name.slice(
        name.lastIndexOf('.') + 1,
        name.length
      )
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: [`/api/MBLFile/previewMBLFile?guid=${!type ? row.podGuid : row.bolGuid}&_t=${Date.now()}`]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          `/api/MBLFile/previewMBLFile?guid=${!type ? row.podGuid : row.bolGuid}&_t=${Date.now()}`
        )
      }
    },
    viewIsa(row) {
      const suffix = row.isaFileName.slice(
        row.isaFileName.lastIndexOf('.') + 1,
        row.isaFileName.length
      )
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: [`/api/SystemFile/preview?guid=${row.isaGuid}&_t=${Date.now()}`]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          `/api/SystemFile/preview?guid=${row.isaGuid}&_t=${Date.now()}`
        )
      }
    },
    uploadRetentionISA(row) {
      this.editData = row
      this.dialogVisible3 = true
    },
    viewRetentionIsa(row) {
      const suffix = row.owerISAFileName.slice(
        row.owerISAFileName.lastIndexOf('.') + 1,
        row.owerISAFileName.length
      )
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: [`/api/SystemFile/preview?guid=${row.owerISAFileGuid}&_t=${Date.now()}`]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          `/api/SystemFile/preview?guid=${row.owerISAFileGuid}&_t=${Date.now()}`
        )
      }
    },
    handleClick(value) {
      this.active = value
    }
  }
}
</script>

<style lang="less" scoped>
.read {
  color: #999999;
  cursor: pointer;
  & + .read {
    margin-left: 30px;
  }
  &.active {
    color:  rgb(18,88,188);
  }
}
.view {
  width: 100%;
  height: auto;
  padding: 20px 0;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  box-sizing: border-box;
  .title {
    width: 72px;
    height: 21px;
    font-size: 16px;
    color: #333333;
    line-height: 21px;
    margin-left: 20px;
  }
  .panel {
    width: 780px;
    padding: 0 20px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    .panel-title {
      height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
      position: relative;
      padding-top: 10px;
      img {
        padding-top: 2px;
      }
    }
    .icon {
      font-size: 20px;
      vertical-align: text-bottom;
    }
    .btn {
      width: 100px;
      height: 30px;
      background: #35ba83;
      border-radius: 2px 2px 2px 2px;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      padding: 0;
      text-align: center;
      cursor: pointer;
    }
  }
  .pod-list {
    width: 780px;
    height: auto;
    padding: 10px 20px 0;
  }
  .add {
    width: 80px;
    height: 30px;
    background: #35ba83;
    border-radius: 2px 2px 2px 2px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    img {
      vertical-align: text-top;
    }
  }
  .lable {
    width: 80px;
    display: inline-block;
    height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    background: #f7f7f7;
    border-radius: 2px 2px 2px 2px;
    vertical-align: bottom;
    text-align: center;
  }
  .value {
    height: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #666666;
    line-height: 20px;
    margin-left: 5px;
  }
  .newUpload {
    width: 60px;
    height: 20px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #35BA83;
    box-sizing: border-box;
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #35BA83;
    cursor: pointer;
    margin: 0 auto;
    & + .newUpload {
      margin-top: 5px;
    }
  }
  .upload {
    border: 1px solid  rgb(18,88,188);
    color:  rgb(18,88,188);
  }
}

/deep/ .el-drawer__body {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
